import React from 'react';
import { Container, Row, Col } from 'reactstrap';

const Policies = () => {
    return (
        <React.Fragment>
            <section className="section bg-light py-5">
                <Container>
                    <Row className="align-items-center gy-4">
                        <div className="text-muted">
                            <div className="text-center">
                                <h2 className="fw-bold mt-5" style={{ fontSize: "2rem", color: "#F15A29" }}>Privacy Policy</h2>
                            </div>
                        </div>
                    </Row>
                    <Row className="justify-content-center mt-4">
                        <Col lg={10}>
                            <ol style={{ lineHeight: '1.8', color: '#333', textAlign: 'justify' }}>
                                <li>
                                    <strong>Information We Collect</strong><br />
                                    We may collect:
                                    <ul>
                                        <li>Basic personal information such as name, email, and contact number</li>
                                        <li>Information submitted via login form</li>
                                        <li>Messages or data shared via WhatsApp communication</li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>How We Use Your Information</strong><br />
                                    Your information may be used to:
                                    <ul>
                                        <li>Respond to inquiries or messages</li>
                                        <li>Communicate regarding products and services</li>
                                        <li>Improve website functionality and user experience</li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>WhatsApp Communication</strong><br />
                                    Messages sent via WhatsApp are governed by WhatsApp’s privacy policy. We do not share your number with third parties and will only use it for business communication.
                                </li>
                                <li>
                                    <strong>Cookies</strong><br />
                                    We may use cookies to improve your browsing experience. You can choose to disable cookies in your browser settings.
                                </li>
                                <li>
                                    <strong>Data Security</strong><br />
                                    We take reasonable measures to protect your information. However, no method of transmission or storage is 100% secure.
                                </li>
                                <li>
                                    <strong>Sharing of Information</strong><br />
                                    We do not sell, rent, or share your personal information with third parties, except:
                                    <ul>
                                        <li>As required by law</li>
                                        <li>With your consent</li>
                                        <li>To trusted service providers bound by confidentiality</li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>Your Rights</strong><br />
                                    You can request access, correction, or deletion of your personal data by contacting us at <a href="mailto:contact@offisoindia.com">contact@offisoindia.com</a>
                                </li>
                                <li>
                                    <strong>Changes to This Policy</strong><br />
                                    We may update this Privacy Policy. The latest version will always be posted on this page.
                                </li>
                                <li>
                                    <strong>Contact Us</strong><br />
                                    For questions about this Privacy Policy, contact:<br />
                                    📧 <a href="mailto:contact@offisoindia.com">contact@offisoindia.com</a>
                                </li>
                            </ol>
                        </Col>
                    </Row>

                </Container>
            </section>
        </React.Fragment>
    );
};

export default Policies;
